"use client"

import { MapPin } from "lucide-react"

const Footer = () => {
  const navigateToHome = () => {
    window.location.href = "/"
  }

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId)
    if (element) element.scrollIntoView({ behavior: "smooth" })
  }

  const footerLinks = {
    company: [
      { name: "About Us", action: () => scrollToSection("about") },
      { name: "Our Story", action: () => scrollToSection("our-story") },
      { name: "Our Team", action: () => scrollToSection("our-experts") },
    ],
    services: [{ name: "E-Claim Solutions", action: () => scrollToSection("solution") }],
    resources: [{ name: "Support Center", action: () => scrollToSection("contactUs") }],
  }

  const technologies = [
    { name: "React", icon: "https://cdn.simpleicons.org/react/61DAFB", color: "#61DAFB" },
    { name: "Node.js", icon: "https://cdn.simpleicons.org/nodedotjs/539E43", color: "#539E43" },
    { name: "Express", icon: "https://cdn.simpleicons.org/express/FFFFFF", color: "#FFFFFF" },
  ]

  return (
    <footer className="bg-transparent text-white py-8 md:py-12 relative">
      <div className="max-w-[1440px] mx-auto px-6">

        {/* Main Grid */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 items-stretch">

          {/* Logo */}
          <div className="flex flex-col">
            <img
              src="/WhatsApp_Image_2025-11-29_at_16.03.15_0d3bfb40-removebg-preview.png"
              alt="Kayan Healthcare Logo"
              onClick={navigateToHome}
              className="w-36 md:w-40 cursor-pointer mb-4"
            />
            <p className="text-gray-300 text-sm md:text-base mb-4">
              Partner with Kayan Healthcare technologies to streamline operations, enhance compliance, and drive
              efficiency through AI powered automation.
            </p>
          </div>

          {/* Company */}
          <div className="flex flex-col">
            <h4 className="font-bold text-white text-base md:text-lg mb-3">Company</h4>
            <div className="flex flex-col gap-2">
              {footerLinks.company.map((link, i) => (
                <button
                  key={i}
                  onClick={link.action}
                  className="text-gray-300 text-sm md:text-base text-left hover:text-yellow-400 hover:underline"
                >
                  {link.name}
                </button>
              ))}
            </div>
          </div>

          {/* Services + Resources */}
          <div className="flex flex-col">
            <h4 className="font-bold text-white text-base md:text-lg mb-3">Services</h4>
            <div className="flex flex-col gap-2 mb-4">
              {footerLinks.services.map((link, i) => (
                <button
                  key={i}
                  onClick={link.action}
                  className="text-gray-300 text-sm md:text-base text-left hover:text-yellow-400 hover:underline"
                >
                  {link.name}
                </button>
              ))}
            </div>

            <h4 className="font-bold text-white text-base md:text-lg mb-3">Resources</h4>
            <div className="flex flex-col gap-2">
              {footerLinks.resources.map((link, i) => (
                <button
                  key={i}
                  onClick={link.action}
                  className="text-gray-300 text-sm md:text-base text-left hover:text-yellow-400 hover:underline"
                >
                  {link.name}
                </button>
              ))}
            </div>
          </div>

          {/* Technology Stack */}
          <div className="flex flex-col md:flex-row items-start gap-6">

            {/* Text */}
            <div className="flex-1">
              <span
                className="text-cyan-400 text-xs font-semibold tracking-widest uppercase inline-block px-3 py-1
                           bg-cyan-500/10 rounded-full border border-cyan-500/20 mb-3"
              >
                TECHNOLOGY STACK
              </span>

              <h4 className="font-bold text-white text-base md:text-lg mb-2 whitespace-nowrap">
                Our Tech, Your Advantage
              </h4>

              <p className="text-gray-400 text-sm leading-relaxed text-left max-w-[380px] break-words hyphens-none">
                We leverage top-tier technology capabilities using React, Node.js, and Express to build reliable,
                <span className="whitespace-nowrap">high-performance digital solutions</span> for mission-critical systems.
              </p>
            </div>

            {/* Icons */}
            <div className="flex md:flex-col gap-4 items-center justify-center mt-6">
              {technologies.map((tech) => (
                <div
                  key={tech.name}
                  className="group relative w-12 h-12 rounded-xl bg-[#0f172a] flex items-center justify-center
                             border border-gray-700 shadow-md transition-all duration-300 hover:scale-110
                             hover:border-cyan-400"
                >
                  <div
                    className="absolute inset-0 rounded-xl blur-lg opacity-0 group-hover:opacity-40 transition"
                    style={{ background: tech.color }}
                  ></div>
                  <img
                    src={tech.icon}
                    alt={tech.name}
                    title={tech.name}
                    className="w-6 h-6 relative z-10"
                  />
                </div>
              ))}
            </div>

          </div>

        </div>

        {/* Contact */}
        <div className="flex justify-start mt-6">
          <div className="flex items-center gap-3">
            <div className="bg-[#2f4b7a] rounded-full w-11 h-11 flex items-center justify-center">
              <MapPin className="text-yellow-400 w-5 h-5" />
            </div>
            <p className="text-gray-300 text-sm">
              Bear Investments Fund – Burdub Block -B 3003, 3rd Floor, Alqouz 3, Dubai, UAE
            </p>
          </div>
        </div>

        <div className="border-t border-blue-500 my-6" />

        <div className="text-center text-gray-300 text-sm">
          © 2025 Kayan Healthcare. All Rights Reserved
        </div>

      </div>
    </footer>
  )
}

export default Footer
